/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Select, Space, notification } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { ColDef } from 'ag-grid-community'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { RootDispatch } from '../../../app/store'
import { exportTenantRechargeList, getMembersTopUpRecord } from '../MembersManagementPageSlice'
import { getPayTypesName, getTypesName, types, typesCZCZTK } from '../../../models/membersPage'
import { DateSelect } from '../../../compnents/form/DateSelect'
import styles from '../MembersManagementPage.module.css'

export const RechargeRecord = (): React.ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const [form] = Form.useForm()

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
    type: 0,
    keyWord: '',
    startTime: '',
    endTime: '',
    detailType: '',
  })

  const [page, setPage] = useState({ items: [], total: 0 })
  const [loading, setLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)

  const exportExcel = () => {
    setExportLoading(true)
    const { current, size, ...rest } = queries
    dispatch(exportTenantRechargeList(rest))
      .then(unwrapResult)
      .then((res: any) => {
        const blob = new Blob([res])
        const fileName = '充值记录.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
        notification.success({ message: '导出成功', duration: 3 })
      })
      .catch(() => {
        notification.error({ message: '导出失败', duration: 3 })
      })
      .finally(() => setExportLoading(false))
  }

  const fetchData = () => {
    setLoading(true)
    dispatch(getMembersTopUpRecord(queries))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records || [],
          total: res.total || 0,
        })
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [queries])

  const handleFinish = (values: any) => {
    setQueries({
      ...queries,
      current: 1,
      detailType: values.detailType?.toString()  ? values.detailType : '',
      keyWord: values.memberName || '',
      startTime: values.timeHead || '',
      endTime: values.timeTail || '',
    })
  }

  const columnDefs: ColDef[] = [
    {
      field: 'no',
      headerName: '序号',
      width: 60,
      minWidth: 60,
      maxWidth: 60,
      flex: 0,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueGetter: (params) => {
        if (params.data?.isSummary) return ''
        if (params.node?.rowIndex != null) {
          return queries.size * (queries.current - 1) + params.node.rowIndex + 1
        }
        return ''
      },
    },
    {
      field: 'memberName',
      headerName: '患者姓名',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      cellRendererFramework: function memberNameCell(params: any) {
        if (params.data?.isSummary) {
          return <div>合计</div>
        }
        return (
          <span>
            {params.value}
            {Number(params.data?.memberDeleted) === 1 && (
              <span style={{ color: '#999999' }}>(已删除)</span>
            )}
          </span>
        )
      },
    },
    {
      field: 'memberPhone',
      headerName: '手机号',
      flex: 1,
      minWidth: 120,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'traderMoney',
      headerName: '充值金额',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => {
        return params.data.type == 1 || params.data.type == 2
          ? '-' + params.data.traderMoney?.toFixed(2)
          : params.data.traderMoney?.toFixed(2)
      },
    },
    {
      field: 'type',
      headerName: '类型',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => {
        return getTypesName(params.value)
      },
    },
    {
      field: 'accountMoney',
      headerName: '账户余额',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => {
        return params.data?.accountMoney?.toFixed(2) ?? ''
      },
    },
    {
      field: 'payType',
      headerName: '支付方式',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      cellRendererFramework: (params: any) => getPayTypesName(Number(params.value)) ?? '-',
    },
    {
      field: 'remarks',
      headerName: '备注',
      flex: 1,
      minWidth: 120,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'updateTime',
      headerName: '操作时间',
      flex: 1,
      minWidth: 160,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'createUserName',
      headerName: '操作员',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
  ]

  const totalTraderMoney = (page.items || []).reduce(
    (sum: number, r: any) => sum + (Number(r.type == 1 || r.type == 2 ? '-' + r.traderMoney : r.traderMoney) || 0),
    0,
  )

  const totalAccountMoney = (page.items || []).reduce(
    (sum: number, r: any) => sum + (Number(r.accountMoney) || 0),
    0,
  )

  const summaryRow = {
    isSummary: true,
    memberName: '合计',
    traderMoney: totalTraderMoney,
    // accountMoney: totalAccountMoney,
  }
  const displayItems = page.items.length ? [...page.items, summaryRow] : page.items

  return (
    <div className={styles.memberContents} style={{ margin: '0 0 5px 0', height: 'calc(100% - 10px)' }}>
      <Form form={form} onFinish={handleFinish}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <Space>
            <Form.Item name="memberName" noStyle>
              <Input
                allowClear
                maxLength={20}
                style={{ width: '20rem' }}
                placeholder="请输入患者姓名/手机号/助记码"
                prefix={<SearchOutlined />}
                onChange={form.submit}
              />
            </Form.Item>
            <Form.Item name="detailType" noStyle>
              <Select
                allowClear
                placeholder="类型"
                style={{ width: 130 }}
                onChange={form.submit}
              >
                {typesCZCZTK.map((k: any) => (
                  <Select.Option value={Number(k)} key={k}>{getTypesName(k)}</Select.Option>
                ))}
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '8.5rem' }}
              labelPrefix=""
              namePrefix="time"
              placeholder="操作时间"
              onChange={form.submit}
            />
            <Button type="primary" htmlType="submit" loading={loading}>
              查询
            </Button>
          </Space>
          <Space>
            <span style={{ color: '#999' }}>（最多支持导出10000条数据，更多请联系客服）</span>
            <Button type="primary" onClick={exportExcel} loading={exportLoading}>导出</Button>
          </Space>
        </div>
      </Form>
      <SimpleAgGrid
        column={columnDefs}
        page={{ items: displayItems, current: queries.current, size: queries.size, total: page.total }}
        isLoading={loading}
        pagination={true}
        getRowStyle={(params: any) => {
          if (params.data?.isSummary) {
            return { backgroundColor: '#d9f2ff' }
          }
          return {}
        }}
        onChangePage={(current, size) =>
          setQueries({ ...queries, current, size })
        }
      />
    </div>
  )
}
